













import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class StarsBackground extends Vue {
  private readonly isMobile!: MobileGetter;
  private showStars = false;
  private yellowStarRatio = 0.2;
  private faintStarRatio = 0.2;

  private get numStars() {
    if (this.isMobile(this.$mq)) {
      return 15;
    }
    return 100;
  }

  private get stars() {
    const starsData = [];
    const starsElement = this.$refs.stars as HTMLSpanElement;
    const starsWidth = starsElement.clientWidth;
    const starsHeight = starsElement.clientHeight;

    const randRange = (a: number, b: number): number => Math.floor(Math.random() * (b - a + 1)) + a;

    for (let i = 0; i < this.numStars; i += 1) {
      const classesRandom = Math.random();
      const delay = `${randRange(1000, 4000)}ms`;
      const duration = `${randRange(3000, 8000)}ms`;
      starsData.push({
        index: i,
        styles: {
          top: `${Math.round(Math.random() * starsHeight)}px`,
          left: `${Math.round(Math.random() * starsWidth)}px`,
          animationDelay: delay,
          webkitAnimationDelay: delay,
          animationDuration: duration,
          webkitAnimationDuration: duration,
        },
        classes: {
          star: true,
          yellow: classesRandom < this.yellowStarRatio,
          faint: 1 - classesRandom < this.faintStarRatio,
        },
      });
    }

    return starsData;
  }

  private mounted() {
    setTimeout(() => (this.showStars = true), 1);
  }
}
